import { useEffect, useSyncExternalStore } from 'react';

const navigationEvent = 'luobo:admin-navigation';
const beforeNavigationEvent = 'luobo:before-admin-navigation';
let currentUrl = '';

export function readAdminRoute(search: string) {
  const query = new URLSearchParams(search);
  return { page: query.get('page') || 'dashboard', editor: query.get('edit') || '' };
}

function confirmNavigation() {
  return window.dispatchEvent(new Event(beforeNavigationEvent, { cancelable: true }));
}

function subscribe(listener: () => void) {
  if (!currentUrl) currentUrl = window.location.href;
  const onPopState = () => {
    if (currentUrl !== window.location.href) {
      if (!confirmNavigation()) window.history.replaceState(null, '', currentUrl);
      else currentUrl = window.location.href;
    }
    listener();
  };
  window.addEventListener('popstate', onPopState);
  window.addEventListener(navigationEvent, listener);
  return () => {
    window.removeEventListener('popstate', onPopState);
    window.removeEventListener(navigationEvent, listener);
  };
}

export function useAdminRoute() {
  const search = useSyncExternalStore(
    subscribe,
    () => window.location.search,
    () => '',
  );
  return readAdminRoute(search);
}

export function navigateAdmin(page: string, editor = '') {
  const url = new URL(window.location.href);
  url.searchParams.set('page', page);
  if (editor) url.searchParams.set('edit', editor);
  else url.searchParams.delete('edit');
  if (url.href === window.location.href) return true;
  if (!confirmNavigation()) return false;
  window.history.pushState(null, '', url);
  currentUrl = url.href;
  window.dispatchEvent(new Event(navigationEvent));
  return true;
}

export function useUnsavedEditor(dirty: boolean) {
  useEffect(() => {
    if (!dirty) return;
    const beforeNavigate = (event: Event) => {
      if (!window.confirm('还有未保存的修改，确定离开编辑页面吗？')) event.preventDefault();
    };
    const beforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener(beforeNavigationEvent, beforeNavigate);
    window.addEventListener('beforeunload', beforeUnload);
    return () => {
      window.removeEventListener(beforeNavigationEvent, beforeNavigate);
      window.removeEventListener('beforeunload', beforeUnload);
    };
  }, [dirty]);
}
